export default __webpack_public_path__ + "static/media/info-red.e8ab7467.svg";